import { httpClient, HttpMethod } from './http-client';
import { AllocationConfigData, AllocationResponse } from '../@types/allocation.type';

export const getAllAllocationConfigs = (): Promise<AllocationResponse[]> => {
  return httpClient<AllocationResponse[]>('/allocationconfigs', HttpMethod.Get);
};

export const createAllocationConfig = (data: AllocationConfigData): Promise<AllocationResponse> => {
  return httpClient<AllocationResponse>('/allocationconfigs', HttpMethod.Post, data);
};

export const updateAllocationConfig = (id: number, data: AllocationConfigData): Promise<AllocationResponse> => {
  return httpClient<AllocationResponse>(`/allocationconfigs/${id}`, HttpMethod.Put, data);
};
